import {
  BASE_URL,
  SNOMED,
  SNOMED_DATA,
  ERROR_MSG,
  API_GATEWAY_KEY,
} from "./Constants";
import Cookies from "js-cookie";

export const fetchSnomedData = async (
  pageNo,
  recordsPerPage,
  urlWithParams
) => {
  let response = await fetch(
    `${BASE_URL}${SNOMED_DATA}/${pageNo}/${recordsPerPage}?${urlWithParams}`,
    {
      headers: {
        Authorization: `Bearer ${Cookies.get("accessToken")}`,
        "x-api-key": API_GATEWAY_KEY,
      },
    }
  );
  return response;
};

export const fetchSnomedDataWithCondition = async (
  pageNo,
  recordsPerPage,
  condition
) => {
  if (condition == null || condition === "") {
    return {
      genericList: [],
      totalPages: 1,
    };
  }
  let response = await fetch(
    `${BASE_URL}${SNOMED_DATA}/${pageNo}/${recordsPerPage}?condition=${condition}`,
    {
      headers: {
        Authorization: `Bearer ${Cookies.get("accessToken")}`,
        "x-api-key": API_GATEWAY_KEY,
      },
    }
  );
  if (response.ok) {
    let data = await response.json();
    return data;
  } else if (response.status === 404) {
    return {
      genericList: [],
      totalPages: 1,
    };
  } else {
    return ERROR_MSG;
  }
};

export const addNewSnomed = async (form) => {
  let response = await fetch(`${BASE_URL}${SNOMED}`, {
    method: "post",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${Cookies.get("accessToken")}`,
      "x-api-key": API_GATEWAY_KEY,
    },
    body: JSON.stringify(form),
  });
  let data = await response.json();
  return data;
};

export const fetchSnomedById = async (snomedId) => {
  let response = await fetch(`${BASE_URL}${SNOMED}/${snomedId}`, {
    headers: {
      Authorization: `Bearer ${Cookies.get("accessToken")}`,
      "x-api-key": API_GATEWAY_KEY,
    },
  });
  return response;
};

export const updateSnomedRecord = async (form) => {
  let response = await fetch(`${BASE_URL}${SNOMED}`, {
    method: "put",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${Cookies.get("accessToken")}`,
      "x-api-key": API_GATEWAY_KEY,
    },
    body: JSON.stringify(form),
  });
  let data = await response.json();
  return data;
};

export const removeSnomedRecord = async (snomedId) => {
  let response = await fetch(`${BASE_URL}${SNOMED}/${snomedId}`, {
    method: "delete",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${Cookies.get("accessToken")}`,
      "x-api-key": API_GATEWAY_KEY,
    },
  });
  if (!response.ok) {
    return ERROR_MSG;
  }
};
